// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".radio-wrapper[data-v-e16df53a]{display:flex;flex-wrap:wrap;gap:12px;align-items:flex-start}.radio-wrapper .v-radio[data-v-e16df53a]{margin:0}.text-body[data-v-e16df53a]{min-height:300px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
